var map = {
	"./assets/fonts/airtel-icons.svg": 946,
	"./assets/fonts/tondo.svg": 947,
	"./assets/svgs/ccp/30/AmericanExpress.svg": 948,
	"./assets/svgs/ccp/30/Mastercard.svg": 949,
	"./assets/svgs/ccp/30/RuPay.svg": 950,
	"./assets/svgs/ccp/30/Visa.svg": 951,
	"./assets/svgs/ccp/60/AmericanExpress/Color.svg": 379,
	"./assets/svgs/ccp/60/AmericanExpress/Grey.svg": 380,
	"./assets/svgs/ccp/60/Mastercard/Color.svg": 381,
	"./assets/svgs/ccp/60/Mastercard/Grey.svg": 382,
	"./assets/svgs/ccp/60/RuPay/Color.svg": 383,
	"./assets/svgs/ccp/60/RuPay/Grey.svg": 384,
	"./assets/svgs/ccp/60/Visa/Color.svg": 385,
	"./assets/svgs/ccp/60/Visa/Grey.svg": 386,
	"./assets/svgs/doubleQuotes.svg": 390,
	"./assets/svgs/illustrations/120/2g-sim.svg": 213,
	"./assets/svgs/illustrations/120/3g-sim.svg": 214,
	"./assets/svgs/illustrations/120/4g-sim.svg": 215,
	"./assets/svgs/illustrations/120/account-manager.svg": 216,
	"./assets/svgs/illustrations/120/app-advisor.svg": 217,
	"./assets/svgs/illustrations/120/bus-tickets.svg": 218,
	"./assets/svgs/illustrations/120/calls.svg": 219,
	"./assets/svgs/illustrations/120/chef.svg": 220,
	"./assets/svgs/illustrations/120/connections.svg": 221,
	"./assets/svgs/illustrations/120/dashboard.svg": 222,
	"./assets/svgs/illustrations/120/data-connectivity.svg": 223,
	"./assets/svgs/illustrations/120/dnd-activate.svg": 224,
	"./assets/svgs/illustrations/120/dnd-desactivate.svg": 225,
	"./assets/svgs/illustrations/120/ensuring-uninterrupted-services-business.svg": 226,
	"./assets/svgs/illustrations/120/find-rates.svg": 227,
	"./assets/svgs/illustrations/120/get-help.svg": 228,
	"./assets/svgs/illustrations/120/international-roaming.svg": 229,
	"./assets/svgs/illustrations/120/internet.svg": 230,
	"./assets/svgs/illustrations/120/iplc.svg": 231,
	"./assets/svgs/illustrations/120/isd-advanced.svg": 232,
	"./assets/svgs/illustrations/120/isd.svg": 233,
	"./assets/svgs/illustrations/120/itfs.svg": 234,
	"./assets/svgs/illustrations/120/maintenance.svg": 235,
	"./assets/svgs/illustrations/120/messages.svg": 236,
	"./assets/svgs/illustrations/120/network-issues.svg": 237,
	"./assets/svgs/illustrations/120/one-more-product.svg": 238,
	"./assets/svgs/illustrations/120/online-shopping.svg": 239,
	"./assets/svgs/illustrations/120/organization.svg": 240,
	"./assets/svgs/illustrations/120/page-not-found.svg": 241,
	"./assets/svgs/illustrations/120/pay-outstanding-invoices.svg": 242,
	"./assets/svgs/illustrations/120/payment-allocated.svg": 243,
	"./assets/svgs/illustrations/120/payment-trends.svg": 244,
	"./assets/svgs/illustrations/120/payment-uncompleted.svg": 245,
	"./assets/svgs/illustrations/120/pharmacy.svg": 246,
	"./assets/svgs/illustrations/120/savings.svg": 247,
	"./assets/svgs/illustrations/120/search-files.svg": 248,
	"./assets/svgs/illustrations/120/second-tv.svg": 249,
	"./assets/svgs/illustrations/120/smart-savings.svg": 250,
	"./assets/svgs/illustrations/120/smartphone-action.svg": 251,
	"./assets/svgs/illustrations/120/thought-leadership-article-on-ddos.svg": 252,
	"./assets/svgs/illustrations/120/upload-tds.svg": 253,
	"./assets/svgs/illustrations/120/whats-next.svg": 254,
	"./assets/svgs/illustrations/120/write.svg": 255,
	"./assets/svgs/illustrations/180/2g-sim.svg": 256,
	"./assets/svgs/illustrations/180/3g-sim.svg": 257,
	"./assets/svgs/illustrations/180/4g-sim.svg": 258,
	"./assets/svgs/illustrations/180/account-manager.svg": 259,
	"./assets/svgs/illustrations/180/calls.svg": 260,
	"./assets/svgs/illustrations/180/connections.svg": 261,
	"./assets/svgs/illustrations/180/dashboard.svg": 262,
	"./assets/svgs/illustrations/180/data-connectivity.svg": 263,
	"./assets/svgs/illustrations/180/discount-tickets.svg": 264,
	"./assets/svgs/illustrations/180/dnd-activate.svg": 265,
	"./assets/svgs/illustrations/180/dnd-desactivate.svg": 266,
	"./assets/svgs/illustrations/180/ensuring-uninterrupted-services-business.svg": 267,
	"./assets/svgs/illustrations/180/find-rates.svg": 268,
	"./assets/svgs/illustrations/180/get-help.svg": 269,
	"./assets/svgs/illustrations/180/international-roaming.svg": 270,
	"./assets/svgs/illustrations/180/internet.svg": 271,
	"./assets/svgs/illustrations/180/iplc.svg": 272,
	"./assets/svgs/illustrations/180/isd-advanced.svg": 273,
	"./assets/svgs/illustrations/180/isd.svg": 274,
	"./assets/svgs/illustrations/180/itfs.svg": 275,
	"./assets/svgs/illustrations/180/maintenance.svg": 276,
	"./assets/svgs/illustrations/180/messages.svg": 277,
	"./assets/svgs/illustrations/180/network-issues.svg": 278,
	"./assets/svgs/illustrations/180/one-more-product.svg": 279,
	"./assets/svgs/illustrations/180/organization.svg": 280,
	"./assets/svgs/illustrations/180/pay-outstanding-invoices.svg": 281,
	"./assets/svgs/illustrations/180/payment-allocated.svg": 282,
	"./assets/svgs/illustrations/180/payment-trends.svg": 283,
	"./assets/svgs/illustrations/180/payment-uncompleted.svg": 284,
	"./assets/svgs/illustrations/180/search-files.svg": 285,
	"./assets/svgs/illustrations/180/thought-leadership-article-on-ddos.svg": 286,
	"./assets/svgs/illustrations/180/upload-tds.svg": 287,
	"./assets/svgs/illustrations/180/whats-next.svg": 288,
	"./assets/svgs/illustrations/240/2g-sim.svg": 289,
	"./assets/svgs/illustrations/240/3g-sim.svg": 290,
	"./assets/svgs/illustrations/240/4g-sim.svg": 291,
	"./assets/svgs/illustrations/240/calls.svg": 292,
	"./assets/svgs/illustrations/240/connections.svg": 293,
	"./assets/svgs/illustrations/240/data-connectivity.svg": 294,
	"./assets/svgs/illustrations/240/discount-tickets.svg": 295,
	"./assets/svgs/illustrations/240/dnd-activate.svg": 296,
	"./assets/svgs/illustrations/240/dnd-desactivate.svg": 297,
	"./assets/svgs/illustrations/240/ensuring-uninterrupted-services-business.svg": 298,
	"./assets/svgs/illustrations/240/find-rates.svg": 299,
	"./assets/svgs/illustrations/240/international-roaming.svg": 300,
	"./assets/svgs/illustrations/240/internet.svg": 301,
	"./assets/svgs/illustrations/240/iplc.svg": 302,
	"./assets/svgs/illustrations/240/isd-advanced.svg": 303,
	"./assets/svgs/illustrations/240/isd.svg": 304,
	"./assets/svgs/illustrations/240/itfs.svg": 305,
	"./assets/svgs/illustrations/240/maintenance.svg": 306,
	"./assets/svgs/illustrations/240/messages.svg": 307,
	"./assets/svgs/illustrations/240/network-issues.svg": 308,
	"./assets/svgs/illustrations/240/one-more-product.svg": 309,
	"./assets/svgs/illustrations/240/organization.svg": 310,
	"./assets/svgs/illustrations/240/pay-outstanding-invoices.svg": 311,
	"./assets/svgs/illustrations/240/payment-allocated.svg": 312,
	"./assets/svgs/illustrations/240/payment-trends.svg": 313,
	"./assets/svgs/illustrations/240/payment-uncompleted.svg": 314,
	"./assets/svgs/illustrations/240/savings.svg": 315,
	"./assets/svgs/illustrations/240/search-files.svg": 316,
	"./assets/svgs/illustrations/240/secure-browsing.svg": 317,
	"./assets/svgs/illustrations/240/thought-leadership-article-on-ddos.svg": 318,
	"./assets/svgs/illustrations/240/upload-tds.svg": 319,
	"./assets/svgs/illustrations/240/whats-next.svg": 320,
	"./assets/svgs/illustrations/240/write.svg": 321,
	"./assets/svgs/illustrations/40/africa.svg": 322,
	"./assets/svgs/illustrations/40/all-regions.svg": 323,
	"./assets/svgs/illustrations/40/asia.svg": 324,
	"./assets/svgs/illustrations/40/europe.svg": 325,
	"./assets/svgs/illustrations/40/north-america.svg": 326,
	"./assets/svgs/illustrations/40/oceania.svg": 327,
	"./assets/svgs/illustrations/40/south-america.svg": 328,
	"./assets/svgs/illustrations/60/africa.svg": 329,
	"./assets/svgs/illustrations/60/all-regions.svg": 330,
	"./assets/svgs/illustrations/60/asia.svg": 331,
	"./assets/svgs/illustrations/60/europe.svg": 332,
	"./assets/svgs/illustrations/60/north-america.svg": 333,
	"./assets/svgs/illustrations/60/oceania.svg": 334,
	"./assets/svgs/illustrations/60/south-america.svg": 335,
	"./assets/svgs/illustrations/other/error-404-280.svg": 336,
	"./assets/svgs/illustrations/other/error-404-320.svg": 337,
	"./assets/svgs/illustrations/other/office-in-a-box.svg": 338
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 945;


//////////////////
// WEBPACK FOOTER
// ./src/uis ^\.\/.*\.svg$
// module id = 945
// module chunks = 0